<script>
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import { faXmark } from "@fortawesome/free-solid-svg-icons";
    import Button from "../ui/Button.svelte";
    import TimeInput from "./TimeInput.svelte";

    export let period;
    period = period ?? {open: {}, close:{}};

    const dispatch = createEventDispatcher();

    function deletePeriod() {
        dispatch("delete", {period});
    }

    $: period.close.day = (period.open.time >= period.close.time) ? period.open.day + 1 : period.open.day;
</script>

<div class="period">
    <TimeInput label="Öffnet" bind:value={period.open.time}></TimeInput>
    <TimeInput label="Schließt" bind:value={period.close.time}></TimeInput>
    <button on:click={deletePeriod}><Fa icon={faXmark}></Fa></button>
</div>

<style>
    .period {
        display: grid;
        grid-template-columns: auto auto 2rem;
    }
</style>